import { OrderLineItemData, Shipment } from '@api/types';
import { OrderContentHeader, OrderLineItem } from '@components';
import { Box } from '@mui/system';

type OrderContentListProps = {
  items: OrderLineItemData[];
  expectedDeliveryDate?: Shipment['expectedDeliveryDate'];
  trackingNumber?: Shipment['trackingNumber'];
  shipmentName?: Shipment['name'];
  trackingLink?: Shipment['trackingLink'];
};

export const OrderContentList = ({
  items,
  expectedDeliveryDate,
  trackingNumber,
  shipmentName,
  trackingLink,
}: OrderContentListProps) => {
  return (
    <Box>
      <OrderContentHeader
        expectedDeliveryDate={expectedDeliveryDate}
        trackingNumber={trackingNumber}
        shipmentName={shipmentName}
        trackingLink={trackingLink}
      />
      <Box
        sx={{
          display: 'grid',
          gridAutoRows: '1fr',
          gap: 2,
        }}
      >
        {items?.map((item) => {
          const url = item.itemUrl;
          const productNo = item.productNo || '';
          const newItem = { ...item, url, productNo };
          return <OrderLineItem lineItem={newItem} key={newItem.code} />;
        })}
      </Box>
    </Box>
  );
};
